const PROP_LIST_COMPONENT_MHP_PROP = document.querySelector('.mhp-property-list-component');

if (PROP_LIST_COMPONENT_MHP_PROP) {
    const TABLE_WRAPPER = PROP_LIST_COMPONENT_MHP_PROP.querySelector('.table-wrapper');
    TABLE_WRAPPER.innerHTML = ' <div class="list-loader"></div>';
    let getPropListMHPData = async function () {
        const NUMB_PER_PAGE = document.querySelector('.num-per-page').value;
        const DATA_SOURCE_PAGE = document.querySelector('.data-source-page-id').value;
        let response = await fetch(
            `${APIPrefix.get()}/search_api/mhp/properties/list?noOfItemsPerPage=${NUMB_PER_PAGE}&developmentId=${DATA_SOURCE_PAGE}`
        );
        if (response.status == 200) {
            let data = await response.json();
            if (data.status === "401") {
                APIUtils.redirectUserToSigninPage();
            } else {
                return data;
            }
        } else {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    };

    getPropListMHPData().then((data) => {
        if (data.status == "failure") {
            TABLE_WRAPPER.innerText = data.message;
        } else {
            if (data.data) {
            const HEADINGS = data.data.headings;
            const ITEMS = data.data.items;
            const CONFIGURATION = data.data.configuration;
            TABLE_WRAPPER.innerText = "";
            const TABLE = document.createElement('table');
            TABLE.setAttribute('class', 'pagination');
            TABLE_WRAPPER.appendChild(TABLE);
            for (const field in data.data) {
                const THEAD = document.createElement('thead');
                const TABLE_ROW = document.createElement('tr');
                THEAD.appendChild(TABLE_ROW);
                const TBODY = document.createElement('tbody');
                if (field == 'headings') {
                    for (const child in HEADINGS) {
                        const HEADER_CELL = document.createElement('th');
                        TABLE_ROW.appendChild(HEADER_CELL);
                        HEADER_CELL.innerText = HEADINGS[child];
                        TABLE.appendChild(THEAD);
                    }
                    //for buttons
                    const HEADER_CELL = document.createElement('th');
                    HEADER_CELL.classList.add('disabled-sorting');
                    TABLE_ROW.appendChild(HEADER_CELL);
                    TABLE.appendChild(THEAD);
                } else if (field == 'items') {
                    for (const child in ITEMS) {
                        const TABLE_ROW = document.createElement('tr');
                        let item = ITEMS[child].fields;
                        let btn = ITEMS[child].button;
                        for (const row in item) {
                            const TABLE_DATA = document.createElement('td');
                            TABLE_ROW.appendChild(TABLE_DATA);
                            if (typeof item[row] === 'object' && item[row] !== null) {
                                if (row === 'propertynumber') {
                                    let link = document.createElement('a');
                                    link.setAttribute('class', 'propertynumber');
                                    link.setAttribute('title', item[row].tooltip);
                                    link.setAttribute('href', item[row].url);
                                    link.innerHTML = item[row].name;
                                    TABLE_DATA.appendChild(link);
                                } else {
                                    let link;
                                    if ((row === 'propertyactionrequired') && (item[row].state === 'active')) {
                                      link = document.createElement('button');
                                      link.setAttribute('type', 'button');
                                    } else {
                                      link = document.createElement('a');
                                    }
                                    link.setAttribute('title', item[row].tooltip);
                                    const hoverIcon = item[row].hoverIconPath ? item[row].hoverIconPath : item[row].activeIconPath;
                                    const activeIcon = item[row].activeIconPath ? item[row].activeIconPath : '';
                                    const disabledIcon = item[row].disabledIconPath ? item[row].disabledIconPath : '';

                                    if (row === 'propertyactionrequired') {
                                        if (item[row].state === 'active') {
                                            link.setAttribute('data-modal', "notificationsModal");
                                            link.setAttribute('class', 'notifications-btn mhp-link-icon');
                                            link.setAttribute('tabindex', '0');
                                            link.innerHTML = `<img data-disabled="${disabledIcon}" data-active="${activeIcon}" data-hover="${hoverIcon}" class="mhp-icon-link" src="${item[row][`${item[row].state}IconPath`]}">`;
                                        }
                                    } else {
                                        if (item[row].state === 'active') {
                                            link.setAttribute('href', item[row].url);
                                            link.setAttribute('class', 'mhp-link-icon icon-active');
                                        } else {
                                            link.setAttribute('class', 'mhp-link-icon icon-disabled');
                                            link.removeAttribute("title");
                                        }
                                        link.innerHTML = `<img data-disabled="${disabledIcon}" data-active="${activeIcon}" data-hover="${hoverIcon}" class="mhp-icon-link" src="${item[row][`${item[row].state}IconPath`]}">`;
                                    }
                                    TABLE_DATA.appendChild(link);
                                }
                            } else {
                                TABLE_DATA.innerText = item[row];
                            }
                            TBODY.appendChild(TABLE_ROW);
                            TABLE.appendChild(TBODY);
                        }

                        if (btn.url !== '') {
                            let link = document.createElement('a');
                            link.setAttribute('title', btn.tooltip);
                            link.setAttribute('href', btn.url);
                            link.innerHTML = btn.name;
                            link.setAttribute('class', 'button button--primary');
                            let NEW_CELL = TABLE_ROW.insertCell(-1);
                            NEW_CELL.appendChild(link);
                        } else {
                            let link = document.createElement('span');
                            link.innerHTML = btn.name;
                            let NEW_CELL = TABLE_ROW.insertCell(-1);
                            NEW_CELL.appendChild(link);
                        }
                    }
                }
            }

            let dataTable = tableUtils.initPaginatedDataTable(PROP_LIST_COMPONENT_MHP_PROP, CONFIGURATION, true, true);

            if (ITEMS === undefined || ITEMS.length == 0) {
                let ERROR_MSG = document.createElement('span');
                ERROR_MSG.innerText = CONFIGURATION.headerTemplateMessage;
                ERROR_MSG.setAttribute('class', 'no-items');
                PROP_LIST_COMPONENT_MHP_PROP.appendChild(ERROR_MSG);
                let TABLE_WRAP = document.querySelector('.table-wrapper');
                TABLE_WRAP.style.display = 'none';
                dataTable.destroy();
            } else {

                let paginationWrapper = PROP_LIST_COMPONENT_MHP_PROP.querySelector('.dataTable-pagination');
                if (paginationWrapper && paginationWrapper.hasChildNodes()) {
                    tableUtils.initPaginationControlStates(dataTable, paginationWrapper);
                    tableUtils.displayFirstPageAfterSort(dataTable, PROP_LIST_COMPONENT_MHP_PROP);
                }

                const ICONS_STATES_FLOW = PROP_LIST_COMPONENT_MHP_PROP.querySelectorAll('.icon-active .mhp-icon-link');
                if (ICONS_STATES_FLOW) {
                    ICONS_STATES_FLOW.forEach((icon) => {
                        icon.addEventListener('mouseover', (e) => {
                            const hoverIcon = e.target.getAttribute('data-hover');
                            e.target.src = hoverIcon;
                        });
                        icon.addEventListener('mouseout', (e) => {
                            const activeIcon = e.target.getAttribute('data-active');
                            e.target.src = activeIcon;
                        });
                    });
                }
            }
        }else{
            TABLE_WRAPPER.innerText = "";
        }
        }
    }).catch((e) => {
        console.log("Error::Property List::", e);
        let msg = document.querySelector('.rest-message--fail').value ? document.querySelector('.rest-message--fail').value : "";
        TABLE_WRAPPER.innerText = msg;
    });
}